













































































import { mapActions, mapGetters } from 'vuex'
import PageContent from '@/components/PageContent.vue'
import MyAssignmentsFilters from './MyAssignmentsFilters.vue'
import ListStatusQuickFilters from '@/components/ListStatusQuickFilters.vue'
import ListStatusBar from '@/components/ListStatusBar.vue'
import Table from '@/components/Table.vue'
import TableNoResults from '@/components/TableNoResults.vue'
import ListPagination from '@/components/ListPagination.vue'
import dataPollingMixin, { IDataPollingOptions } from '@/mixins/data-polling-mixin'
import autoReloadMixin from '@/mixins/auto-reload-mixin'
import AssignmentRow from './AssignmentRow.vue'
import ValidityCounter from './ValidityCounter.vue'
import MyAssignmentsTableTitles from './MyAssignmentsTableTitles.vue'
import { SEGMENT_EVENTS, trackEvent } from '@/analytics/segment'
import {
  OrderAssignmentFiltersRequest,
  OrderAssignmentState
} from '@/services/models/order-assignments-model'

export default {
  components: {
    PageContent,
    MyAssignmentsFilters,
    ListStatusQuickFilters,
    ListStatusBar,
    ListPagination,
    Table,
    TableNoResults,
    AssignmentRow,
    ValidityCounter,
    MyAssignmentsTableTitles
  },
  mixins: [
    dataPollingMixin(
      'loadAssignmentUpdates',
      [],
      IDataPollingOptions.getPollingOptions(true)
    ),
    autoReloadMixin('loadAssignmentsWithQuery')
  ],
  data() {
    return {
      loadingInitially: true as boolean
    }
  },
  computed: {
    ...mapGetters([
      'assignments',
      'assignmentsPagination',
      'assignmentUpdatesCount',
      'currentAssignmentsStatus'
    ]),
    isOpenAssignmentList(): boolean {
      return this.currentAssignmentsStatus === OrderAssignmentState.Pending
    },
    emptyStateTitle(): string {
      return this.$t(
        this.isAnyFilterEnabled
          ? 'table.empty.filters.title'
          : 'myAssignments.assignmentList.empty.noFilters.title'
      )
    },
    emptyStateText(): string {
      return this.$t(this.isAnyFilterEnabled ? 'table.empty.filters.text' : '')
    },
    isAnyFilterEnabled(): boolean {
      // eslint-disable-next-line
      const { page, size, ...rest } = this.$route.query
      return !!Object.keys(rest).length
    },
    listIsEmpty(): boolean {
      return !this.assignments.length
    }
  },
  methods: {
    ...mapActions([
      'loadAssignments',
      'loadAssignmentUpdates',
      'acceptAssignment',
      'rejectAssignment',
      'triggerReload'
    ]),
    isOpen(state): boolean {
      return state === OrderAssignmentState.Pending
    },
    async onClickAccept(assignmentId: number): Promise<void> {
      this.loading = true
      await this.acceptAssignment(assignmentId)
      trackEvent(SEGMENT_EVENTS.ASSIGNMENTS_ACCEPT_CLICK, {
        assignmentId
      })
      this.loading = false
    },
    async onClickReject(assignmentId: number): Promise<void> {
      this.loading = true
      await this.rejectAssignment(assignmentId)
      trackEvent(SEGMENT_EVENTS.ASSIGNMENTS_REJECT_CLICK, {
        assignmentId
      })
      this.loading = false
    },
    async loadAssignmentsWithQuery(
      query: Partial<OrderAssignmentFiltersRequest>
    ): Promise<void> {
      this.loading = true
      await this.loadAssignments(query)
      this.loading = false
      this.loadingInitially = false
    }
  }
}
